import { Box, Stack, Typography, styled } from "@mui/material"
import {
  Doughnut,
  type DoughnutDatum,
  type DoughnutProps,
  formatPercentage,
  noDecimalsFormatOptions,
} from "@pharmupp/p3-front-commons"
import { Clock } from "react-feather"
import { FamilyInfoTooltip } from "./FamilyInfoTooltip"

export const PercentageDoughnut = <T extends DoughnutDatum>({
  title,
  tooltip,
  percentage,
  splits,
  CustomTooltip,
}: {
  title: string
  tooltip?: string | null
  percentage?: number
  splits: T[]
  CustomTooltip?: DoughnutProps<T>["CustomTooltip"]
}) => (
  <DoughnutItem>
    <Stack direction="row" alignItems="center" gap={1}>
      <Title>{title}</Title>
      <FamilyInfoTooltip tooltip={tooltip} />
    </Stack>
    <ChartContainer>
      <Doughnut
        data={splits}
        CustomTooltip={CustomTooltip}
        emptySlot={{ Icon: Clock, message: "Calcul en cours" }}
      >
        <Percentage>
          {formatPercentage(percentage, noDecimalsFormatOptions)}
        </Percentage>
      </Doughnut>
    </ChartContainer>
  </DoughnutItem>
)

const DoughnutItem = styled(Stack)(({ theme: { spacing } }) => ({
  alignItems: "center",
  textAlign: "center",
  gap: spacing(2),
}))

const Title = styled(Typography)({
  fontWeight: "bold",
  textTransform: "uppercase",
})
Title.defaultProps = {
  variant: "13px",
}

const ChartContainer = styled(Box)({
  height: "270px",
  aspectRatio: 1,
})

const Percentage = styled(Typography)(({ theme: { palette } }) => ({
  fontWeight: 600,
  color: palette.primary.dark1,
}))
Percentage.defaultProps = {
  variant: "30px",
}
